module.exports = __webpack_public_path__ + "static/media/image.c2f05319.webm";